import React, { useState, useEffect } from 'react';

export default function CookieBanner() {
    const [show, setShow] = useState(false);
    const [showPreferences, setShowPreferences] = useState(false);
    const [preferences, setPreferences] = useState({
        essential: true,
        analytics: false,
        marketing: false
    });

    useEffect(() => {
        const consent = localStorage.getItem('hostit_cookie_consent');
        if (!consent) {
            setShow(true);
        } else {
            try {
                const parsed = JSON.parse(consent);
                if (typeof parsed === 'object') setPreferences(parsed);
            } catch(e) {
                // Ignore legacy simple strings
            }
        }
    }, []);

    const acceptAll = () => {
        const allConsent = { essential: true, analytics: true, marketing: true };
        localStorage.setItem('hostit_cookie_consent', JSON.stringify(allConsent));
        setPreferences(allConsent);
        setShow(false);
    };

    const savePreferences = () => {
        localStorage.setItem('hostit_cookie_consent', JSON.stringify(preferences));
        setShowPreferences(false);
        setShow(false);
    };

    if (!show) return null;

    return (
        <>
            {!showPreferences ? (
                <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-[250] flex flex-col sm:flex-row justify-between items-center gap-4 shadow-lg border-t border-gray-800 animate-fade-in-up">
                    <div className="text-sm text-gray-300 text-center sm:text-left">
                        <p>We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.</p>
                        <div className="mt-1 space-x-2">
                            <a href="#privacy-policy" className="underline hover:text-white">Privacy Policy</a>
                            <span className="text-gray-600">|</span>
                            <a href="#terms-of-service" className="underline hover:text-white">Terms of Service</a>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <button onClick={() => setShowPreferences(true)} className="text-gray-300 hover:text-white text-sm font-semibold transition underline whitespace-nowrap">
                            Manage Preferences
                        </button>
                        <button onClick={acceptAll} className="bg-pink-600 text-white px-6 py-2 rounded-full font-bold text-sm hover:bg-pink-700 transition whitespace-nowrap shadow-lg">
                            Accept All
                        </button>
                    </div>
                </div>
            ) : (
                <div className="fixed inset-0 bg-black/60 z-[300] flex items-center justify-center p-4 animate-fade-in">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 text-gray-900">
                        <h3 className="text-xl font-bold mb-2">Cookie Preferences</h3>
                        <p className="text-sm text-gray-600 mb-6">Manage how we use cookies on our site. Essential cookies cannot be disabled as they are required for the site to function properly.</p>
                        
                        <div className="space-y-4 mb-6">
                            <div className="flex items-center justify-between bg-gray-50 p-3 rounded-lg border border-gray-100">
                                <div>
                                    <h4 className="font-semibold text-sm text-gray-900">Essential Cookies</h4>
                                    <p className="text-xs text-gray-500 mt-0.5">Required for authentication and security.</p>
                                </div>
                                <input type="checkbox" checked={true} disabled className="h-5 w-5 text-pink-600 rounded opacity-50 cursor-not-allowed" />
                            </div>
                            <div className="flex items-center justify-between p-3 border-b border-gray-50">
                                <div>
                                    <h4 className="font-semibold text-sm text-gray-900">Analytics Cookies</h4>
                                    <p className="text-xs text-gray-500 mt-0.5">Help us improve by measuring site usage.</p>
                                </div>
                                <input 
                                    type="checkbox" 
                                    checked={preferences.analytics} 
                                    onChange={(e) => setPreferences(prev => ({...prev, analytics: e.target.checked}))}
                                    className="h-5 w-5 text-pink-600 rounded focus:ring-pink-500 cursor-pointer" 
                                />
                            </div>
                            <div className="flex items-center justify-between p-3">
                                <div>
                                    <h4 className="font-semibold text-sm text-gray-900">Marketing Cookies</h4>
                                    <p className="text-xs text-gray-500 mt-0.5">Used to deliver relevant advertisements.</p>
                                </div>
                                <input 
                                    type="checkbox" 
                                    checked={preferences.marketing} 
                                    onChange={(e) => setPreferences(prev => ({...prev, marketing: e.target.checked}))}
                                    className="h-5 w-5 text-pink-600 rounded focus:ring-pink-500 cursor-pointer" 
                                />
                            </div>
                        </div>
                        
                        <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
                            <button onClick={acceptAll} className="px-5 py-2.5 text-gray-700 font-semibold hover:bg-gray-100 rounded-lg transition text-sm">Accept All</button>
                            <button onClick={savePreferences} className="px-5 py-2.5 bg-gray-900 text-white rounded-lg font-bold hover:bg-black transition shadow-md text-sm">
                                Save Preferences
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}